import { memo } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { userDetailsValidation } from "../../utils/validation";

const dialog = {
  width: "100%",
  borderRadius: "50px",
};

function EditUserModel(props) {
  const { open, handleClose, handleAgree, user, setUpdateUser } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [error, setError] = useState();
  useEffect(() => {
    setError({
      firstName: false,
      lastName: false,
      userName: false,
      email: false,
      emailMissMatch: false,
      mobileNotValid: false,
      mobile: false,
    });
  }, [setUpdateUser, user]);
  const handleUpdate = () => {
    const accessCreate = userDetailsValidation(user, setError);
    if (accessCreate) {
      handleAgree();
      handleClose();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <div style={dialog}>
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
          {"Edit User"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ display: "block" }}>
            <Grid item>
              <Grid item>
                <InputLabel style={{ margin: "5px" }}>First Name</InputLabel>
                <TextField
                  id="firstName"
                  variant="outlined"
                  value={user?.firstName}
                  onChange={(val) =>
                    setUpdateUser((preValue) => ({
                      ...preValue,
                      firstName: val.target.value,
                    }))
                  }
                  style={{ margin: "5px", width: "300px" }}
                />
                {error?.firstName && (
                  <Typography component={"p"} style={{ color: "red" }}>
                    please enter first Name
                  </Typography>
                )}
              </Grid>
              <InputLabel style={{ margin: "5px" }}>Last Name</InputLabel>
              <TextField
                id="LastName"
                variant="outlined"
                value={user?.lastName}
                onChange={(val) =>
                  setUpdateUser((preValue) => ({
                    ...preValue,
                    lastName: val.target.value,
                  }))
                }
                style={{ margin: "5px", width: "300px" }}
              />
              {error?.lastName && (
                <Typography component={"p"} style={{ color: "red" }}>
                  please enter last Name
                </Typography>
              )}
            </Grid>
            <Grid item>
              <InputLabel style={{ margin: "5px" }}>Email</InputLabel>
              <TextField
                id="email"
                variant="outlined"
                type="email"
                value={user?.email}
                onChange={(val) =>
                  setUpdateUser((preValue) => ({
                    ...preValue,
                    email: val.target.value,
                  }))
                }
                style={{ margin: "5px", width: "300px" }}
              />
              {error?.email && (
                <Typography component={"p"} style={{ color: "red" }}>
                  please enter email
                </Typography>
              )}
            </Grid>
            <Grid item>
              <InputLabel style={{ margin: "5px" }}>Mobile</InputLabel>
              <TextField
                id="mobileNo"
                variant="outlined"
                type="mobile"
                value={user?.mobile}
                onChange={(val) =>
                  setUpdateUser((preValue) => ({
                    ...preValue,
                    mobile: val.target.value,
                  }))
                }
                style={{ margin: "5px", width: "300px" }}
              />
            </Grid>
            {error?.mobile && (
              <Typography component={"p"} style={{ color: "red" }}>
                please enter Mobile Number
              </Typography>
            )}
            {error?.mobileNotValid && (
              <Typography component={"p"} style={{ color: "red" }}>
                please enter Valid Mobile Number
              </Typography>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            style={{ border: "1px solid #35AA2B" }}
            autoFocus
          >
            Skip
          </Button>
          <Button
            onClick={handleUpdate}
            style={{
              backgroundColor: "#35AA2B",
              color: "#05234A",
              fontWeight: "600px",
            }}
          >
            Update
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default memo(EditUserModel);
